import { useEffect, useState, Fragment } from "react";

// Material UI
import { Divider, Typography, Grid } from "@mui/material";
import { Box } from '@arredo/reactjs-ui'

// Components
import Info from "./Info";
import Total from "./Total";
import { cashTypes, cashTypesFormat } from "../../../models/CashRegisterMovementEntity";

// Hooks
import useUser from "../../../hooks/user/useUser";


const ArchingTotals = ({ totals, detail, onInputChange, viewMovements }) => {
    const [realSubtotals, setRealSubtotals] = useState({});
    const [totalValue, setTotalValue] = useState({});
    const { business } = useUser();

    Object.keys(detail)
        .forEach(d => {
            if (d !== cashTypes.cash && detail[d].real === 0) {
                detail[d].real = detail[d].total;
            }
        });

    const details = Object
        .keys(cashTypesFormat)
        .filter(type => type.startsWith(cashTypes.cash))
        .filter(type => business?.currencies?.find(x => x === type.substring(cashTypes.cash.length)));

    useEffect(() => {
        if (!!detail && !!business && !!totals) {
            let totalCalc = {};
            const subtotals = { ...realSubtotals };
            business.currencies?.forEach(c => {
                const key = cashTypes.cash + c;
                const item = detail[key];
                const totalItem = totals[key];
                const price = totalItem?.price || 1;

                const lastClosureAmount = (Number(totalItem?.lastClosureAmount) * price) || 0;
                const ingress = (Number(totalItem?.ingress) * price) || 0;
                const egress = (Number(totalItem?.egress) * price) || 0;
                const total = (Number(totalItem?.total) * price) || 0;
                const diff = (Number(totalItem?.total) * price) || 0;
                const real = (Number(item?.real) * price) || 0;

                subtotals[key] = real;
                totalCalc = {
                    lastClosureAmount: (totalCalc.lastClosureAmount || 0) + lastClosureAmount,
                    ingress: (totalCalc.ingress || 0) + ingress,
                    egress: (totalCalc.egress || 0) + egress,
                    total: (totalCalc.total || 0) + total,
                    diff: (totalCalc.diff || 0) + diff,
                    real: (totalCalc.real || 0) + real,
                }
            });
            setRealSubtotals(subtotals);
            setTotalValue(totalCalc);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business, detail, totals])

    return (
        <Box header={
            <Typography variant='h5'>
                <strong>Arqueo</strong>
            </Typography>
        }
        >
            <Grid container spacing={2}>
                <Grid size={12}>

                </Grid>
                <Grid size={12}>
                    <Info
                        isTitles
                        color
                        highlight
                        actions={Boolean(viewMovements)}
                        price='Cotización'
                        lastClosureAmount='Apertura'
                        ingress='Ingresos'
                        egress='Egresos'
                        total='Total'
                        real='Real'
                        diff='Diferencia'
                    />
                </Grid>
                {
                    totals &&
                    <Grid size={12}>
                        <Grid container spacing={1}>
                            {
                                details.map((type, index) =>
                                    <Fragment key={type}>
                                        <Grid size={12}>
                                            <Total
                                                diff
                                                cashType={type}
                                                totals={totals}
                                                detail={detail}
                                                onInputChange={onInputChange}
                                                viewMovements={viewMovements && (() => viewMovements({ cashType: cashTypes.cash }))}
                                            />
                                        </Grid>
                                        {
                                            details.length - 1 > index &&
                                            <Grid size={12}>
                                                <Divider light variant="middle" />
                                            </Grid>
                                        }
                                    </Fragment>
                                )
                            }
                        </Grid>
                    </Grid>
                }
                <Grid size={12}>
                    <Divider />
                </Grid>
                <Grid size={12}>
                    <Grid container spacing={1}>
                        {
                            business?.currencies?.map((curr, index) => {
                                const item = totals?.[cashTypes.cash + curr];
                                return (
                                    <Fragment key={index}>
                                        <Grid size={12}>
                                            <Info
                                                highlight
                                                price='---'
                                                actions={Boolean(viewMovements)}
                                                description={`Subtotal ${curr}:`}
                                                lastClosureAmount={item?.lastClosureAmount * item?.price || 0}
                                                ingress={item?.ingress * item?.price || 0}
                                                egress={item?.egress * item?.price || 0}
                                                total={item?.total * item?.price || 0}
                                                diff={item?.total * item?.price || 0}
                                                real={realSubtotals[cashTypes.cash + curr] || 0}
                                            />
                                        </Grid>
                                        {business.currencies.length - 1 > index &&
                                            <Grid size={12}>
                                                <Divider light variant="middle" />
                                            </Grid>
                                        }
                                    </Fragment>
                                );
                            })
                        }
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <Divider />
                </Grid>
                <Grid size={12}>
                    <Info
                        highlight
                        price='---'
                        actions={Boolean(viewMovements)}
                        description={`Total en ${business?.defaultCurrency}:`}
                        lastClosureAmount={totalValue?.lastClosureAmount || 0}
                        ingress={totalValue?.ingress || 0}
                        egress={totalValue?.egress || 0}
                        total={totalValue?.total || 0}
                        diff={totalValue?.total - (totalValue?.real || 0)}
                        real={totalValue?.real || 0}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default ArchingTotals;